/**
 * 品牌鲸鱼（跃出云层的鲸）。原稿是单色 currentColor 的 512×512 symbol。
 *
 * 产品里一律**不带底框**、**不用彩色**：只出主体，颜色跟随文字色（继承 foreground，
 * 浅色下近黑、暗色下近白），跟站内 zinc 中性配色一致。
 * 不透明底版本只留作 apple-touch-icon（iOS 图标需要底），见 public/brand/。
 */
const WHALE =
  'M69 170C74 125 112 92 163 87C215 81 256 108 284 150C311 191 322 218 353 232C369 213 376 193 372 172C370 162 376 158 383 167C398 184 405 202 400 222C420 210 443 215 461 204C470 199 475 204 471 214C459 247 435 265 402 266C388 296 366 316 340 325C353 335 370 341 382 343C391 345 390 352 381 355C345 366 310 349 287 324C246 348 195 346 151 325C98 300 61 242 69 170ZM88 192C97 244 130 286 173 304C194 313 213 316 230 313C207 301 191 285 184 269C178 256 182 253 194 258C218 269 236 288 253 301C264 309 274 315 282 317C264 299 249 272 235 255C194 206 143 184 88 192Z'
const CLOUDS =
  'M38 376C32 358 46 345 66 346C74 320 109 313 132 330C145 340 151 350 151 360C185 379 222 383 260 377C280 375 299 370 316 362C302 379 278 391 251 399C289 402 322 398 348 386C360 370 382 365 402 374C411 344 441 335 458 351C468 361 471 372 467 381C479 386 482 394 474 403C466 413 450 417 428 416H135C94 416 62 402 38 376Z'

/** 鲸鱼 + 云层整体的视觉中心，缩放时以它为锚点。 */
const CENTER = 'translate(256 256) scale(0.83) translate(-260 -251.5)'

/**
 * viewBox 紧贴图形（四周留 ~5% 边距）。用 0 0 512 512 的原始方框时，
 * 主体只占七成宽，小尺寸（标签页 favicon、32px 图标）会显得比邻居小一圈。
 */
const VIEW_BOX = '49 97 410 317'

interface BrandProps {
  className?: string
}

export function BrandMark({ className }: BrandProps) {
  return (
    <svg
      viewBox={VIEW_BOX}
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <g transform={CENTER}>
        <path fillRule="evenodd" d={WHALE} className="fill-foreground transition-colors duration-300" />
        <path d={CLOUDS} className="fill-[#087f71]/90 dark:fill-[#087f71] transition-colors duration-300" />
      </g>
    </svg>
  )
}
